import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import './index.css';
import App from './App';
import { KeycloakProvider } from './contexts/KeycloakContext';
import { WorkspaceProvider } from './contexts/WorkspaceContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Router>
      <KeycloakProvider>
        <WorkspaceProvider>
          <App />
        </WorkspaceProvider>
      </KeycloakProvider>
    </Router>
  </React.StrictMode>
);
